import type { NextPage } from "next";
import { NskHead } from "~/components/common/head/NskHead";
import Loading from "~/components/common/parts/loading/Loading";
import { Page as Component } from "~/components/specifics/settings/staffs/profiles/edit/Page";
import { useIdQueryHandler } from "~/hooks/useIdQueryHandler";

export const PATH = (staffId: number): string =>
	`/settings/staffs/${staffId}/profiles`;
const Home: NextPage = () => {
	const id = useIdQueryHandler("staffId");
	if (id === null) return <Loading isLoading />;

	return (
		<>
			<NskHead title="担当者編集" />
			<Component id={id} />
		</>
	);
};

export default Home;
